import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styles from "../setting.module.css";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import { ReactComponent as VectorSuccess } from "../../../utils/assets/Vector_success.svg";
import {
    centeredModalBoxSx,
    modalBackdropProps,
} from "../../../utils/styles/modal.overlay";

const style = centeredModalBoxSx({
    width: 700,
    maxWidth: "calc(100vw - 48px)",
    overflow: "hidden",
    p: "1.5rem 1.5rem 0",
});

export default function SuccessEmailModalForAdmin(props) {
    const { setOpen, open, setOpenAuthenticationBefore } = props;

    useEffect(() => {
        setOpenAuthenticationBefore(false);
        // eslint-disable-next-line
    }, [open]);

    const handleCloseModal = () => {
        setOpen(false);
        window.location.reload();
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={() => handleCloseModal()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropProps={modalBackdropProps}
            >
                <Box sx={style}>
                    <div className={styles.successModalBody}>
                        <div className={styles.successModalCloseRow}>
                            <ModalCloseButton
                                style={{ position: "static" }}
                                onClick={() => handleCloseModal()}
                            />
                        </div>
                        <div className={styles.successModalIcon}>
                            <VectorSuccess />
                        </div>
                        <p className={styles.successModalMessage}>
                            Your email has now been changed!
                        </p>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
